import {getUserHash} from './index';

export const TrackRegistration = (formData: any) => {
  // @ts-ignore
  const fbq = window.fbq || global.fbq;
  // @ts-ignore
  if (fbq && typeof fbq === 'function') {
    // @ts-ignore
    fbq('track', 'CompleteRegistration');
  }

  // @ts-ignore
  const ga = window.ga || global.ga;
  // @ts-ignore
  if (ga && typeof ga === 'function') {
    // @ts-ignore
    ga('set', 'uid', formData.email);
    // @ts-ignore
    ga('send', {
      hitType: 'event',
      eventCategory: 'email-signup',
      eventAction: 'success',
      eventLabel: formData.email,
    });
  }
};

export const setFreshChatUserData = (user?: any) => {
  const setUserInterval = setInterval(() => {
    const initData = {
      app_id: 'kxq8ogrw',
    };
    if (user && user.firstName && user.email) {
      const userInfo = {
        email: user.email,
        name: user.firstName + ' ' + user.lastName,
        user_hash: getUserHash(),
      };
      //@ts-ignore
      global.window &&
        //@ts-ignore
        window.Intercom('boot', {
          ...initData,
          ...userInfo,
        });
    }
    clearInterval(setUserInterval);
  }, 2000);
};
